{
  "partner": {
    "yobante": "Yobante Express",
    "sawa": "Sawa Delivery",
    "yango": "Yango Delivery",
    "own_fleet": "Djayma Delivery"
  },
  "slots": {
    "title": "Choose a delivery slot",
    "loading": "Loading available slots...",
    "select_zone_date": "Please select a zone and date.",
    "none_available": "No slots available for this date.",
    "full": "Full",
    "remaining": "{{count}} spot left",
    "remaining_plural": "{{count}} spots left"
  },
  "zone": {
    "title": "Delivery zone",
    "from_price": "From {{price}}",
    "minutes": "{{count}} min",
    "hours": "{{count}} h",
    "hours_minutes": "{{hours}} h {{minutes}} min",
    "zones": {
      "dakar": "Dakar",
      "thies-mbour": "Thiès-Mbour",
      "kaolack": "Kaolack",
      "saint-louis": "Saint-Louis",
      "fatick": "Fatick",
      "diourbel-touba": "Diourbel-Touba"
    }
  },
  "tracking": {
    "title": "Delivery tracking",
    "status": {
      "pending": "Pending",
      "preparation": "Preparation",
      "en_route": "En route",
      "arrived": "Arrived",
      "delivered": "Delivered",
      "cancelled": "Cancelled"
    },
    "cancelled": "This delivery has been cancelled.",
    "driver_info": "Your driver",
    "estimated_arrival": "Estimated arrival:",
    "map_placeholder": "Real-time tracking coming soon"
  },
  "yango": {
    "title": "Yango Console",
    "subtitle": "Dispatch and track deliveries via Yango",
    "refresh": "Refresh",
    "dispatch": "Dispatch via Yango",
    "confirm_dispatch": "Confirm dispatch of {{ref}}?",
    "confirm": "Confirm",
    "cancel_action": "Cancel",
    "search_placeholder": "Search by order, customer, or address...",
    "empty": "No Yango dispatches yet.",
    "error": "Unable to load dispatches. Please try again.",
    "retry": "Retry",
    "filter": {
      "all": "All",
      "pending": "Pending",
      "searching": "Searching",
      "in_transit": "In transit",
      "delivered": "Delivered",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "status": {
      "pending": "Pending",
      "searching_driver": "Searching driver",
      "driver_assigned": "Driver assigned",
      "pickup_arrived": "Arrived at pickup",
      "in_transit": "In transit",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "failed": "Failed"
    },
    "col": {
      "order_ref": "Order",
      "customer": "Customer",
      "address": "Delivery address",
      "status": "Status",
      "driver": "Driver",
      "cost": "Cost",
      "date": "Date"
    },
    "kpi": {
      "total_dispatches": "Total dispatches",
      "total_cost": "Total cost",
      "avg_cost": "Avg. cost",
      "pending": "In progress",
      "delivered": "Delivered",
      "failed": "Failed"
    }
  }
}
